@if (loaded) {
  <div class="container py-5 text-center">
    <img class="d-block margin" src="../../../assets/img/thumbnail_Flygets-logo.png" alt="Flygets logo-retina">
    <h2>{{ 'PARKIFLY.PAYMENT.CHOOSE_PAYMENT' | transloco}}</h2>
    <p class="lead">{{'PARKIFLY.PAYMENT.PAY_WITH_OPTIONS' | transloco}}</p>
    <p>{{'PARKIFLY.PAYMENT.PAYEES_NAMES' | transloco}}</p>
    <!-- <button mat-raised-button [routerLink]="['/flygets/checkout/receipt/', orderId]">VISA KVITTO</button> -->
    <mat-tab-group mat-align-tabs="center" (selectedIndexChange)="selectedTabChange($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          <img src="../../../../assets/img/image-1-swish-icon.png" class="Image1 w-7 h-10 mr-2 mb-2">
          <span>Swish</span>
        </ng-template>
        <div class="mt-3" id="swedbank-pay-seamless-view-page-swish"></div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <svg width="35" height="33" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path
              d="M2.13477 24C2.13477 24.9283 2.52895 25.8185 3.23059 26.4749C3.93224 27.1313 4.88387 27.5 5.87615 27.5H28.3244C29.3167 27.5 30.2683 27.1313 30.97 26.4749C31.6716 25.8185 32.0658 24.9283 32.0658 24V14.375H2.13477V24ZM6.54425 19.25C6.54425 18.7527 6.75542 18.2758 7.1313 17.9242C7.50718 17.5725 8.01698 17.375 8.54856 17.375H11.7555C12.287 17.375 12.7968 17.5725 13.1727 17.9242C13.5486 18.2758 13.7598 18.7527 13.7598 19.25V20.5C13.7598 20.9973 13.5486 21.4742 13.1727 21.8258C12.7968 22.1775 12.287 22.375 11.7555 22.375H8.54856C8.01698 22.375 7.50718 22.1775 7.1313 21.8258C6.75542 21.4742 6.54425 20.9973 6.54425 20.5V19.25ZM28.3244 5.5H5.87615C4.88387 5.5 3.93224 5.86875 3.23059 6.52513C2.52895 7.1815 2.13477 8.07174 2.13477 9V10.625H32.0658V9C32.0658 8.07174 31.6716 7.1815 30.97 6.52513C30.2683 5.86875 29.3167 5.5 28.3244 5.5Z"
              fill="#FF5B00" />
          </svg>
          <span>{{ 'PARKIFLY.PAYMENT.CARD' | transloco}}</span>
        </ng-template>
        <div class="mt-3" id="swedbank-pay-seamless-view-page-creditcard"></div>
      </mat-tab>
    </mat-tab-group>
    <app-small-footer></app-small-footer>
  </div>
}